// apiInterceptors.js
import axios from 'axios';
import { toast } from 'react-toastify';
import { handleLogout } from '../utils/logout';

// --------- AXIOS INTERCEPTOR ---------
// Configure axios interceptors
const setupAxiosInterceptors = () => {
  // Response interceptor for Axios
  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.data?.status === "FAIL" && 
          error.response?.data?.message === "Unauthorized access - Invalid token") {
        // toast.error("Unauthorized access - Invalid token. Please Login Again");
        handleLogout();
      
      }
      return Promise.reject(error);
    }
  );
};

// --------- FETCH INTERCEPTOR ---------
// Override the global fetch function
const setupFetchInterceptor = () => {
  const originalFetch = window.fetch;
  
  window.fetch = async function(...args) {
    // Call the original fetch
    const response = await originalFetch.apply(this, args);
    
    // Clone the response so we can read it without consuming it
    const clone = response.clone();
    
    try {
      const data = await clone.json();
      
      // Check for token error
      if (data.status === "FAIL" && data.message === "Unauthorized access - Invalid token") {
        // toast.error("Unauthorized access - Invalid token. Please Login Again");
        handleLogout();
      }
    } catch (e) {
      // Silently handle JSON parsing errors
      // This will happen for non-JSON responses, which is fine
    }
    
    // Return the original response so the calling code works normally
    return response;
  };
};

// Initialize both interceptors
export const initApiInterceptors = () => {
  setupAxiosInterceptors();
  setupFetchInterceptor();
};

